const FilterCounts = [
  { 'label': 'Total Scheduled Vessels', 'count': 0, 'field': 'status', value: 'Scheduled', key: 'total_vessel_scheduled' },
  { 'label': 'Vessels in Execution', 'count': 0, 'field': 'status', value: 'InExecution', key: 'total_vessel_in_execution' },
  { 'label': 'Vessels Not Yet Executed', 'count': 0, 'field': 'status', value: 'NotExecution', key: 'total_vessel_not_execution' },
  { 'label': 'Vessels Without SR', 'count': 0, 'field': 'status', value: 'WithoutSR', key: 'total_vessel_without_sr' }
]

const DefaultAlert = {
  msg: '',
  type: '',
  success: false,
  visible: false,
}

const DefaultDataState = {
  skip: 0,
  take: 20,
  filter: null,
  filterString: '[]'
}

const EnableDisableAction = (dataItem) => {
  const status = String(dataItem.plan_name).toLowerCase()

  if (status === 'upcoming vessel' || status === 'vessel berthing' || status === 'closed') {
    return {
      edit: false,
      generate: false,
    }
  }

  if (status === 'unresolved') {
    return {
      edit: true,
      generate: false,
    }
  }

  return {
    edit: true,
    generate: true,
  }
}

export default {
  FilterCounts,
  DefaultAlert,
  DefaultDataState,
  EnableDisableAction,
}